import { UPSERT_TOOLTIP_INFO } from '../../constants/actions/policy';

export function upsertTooltipInfo(payload) {
    return {
        type: UPSERT_TOOLTIP_INFO,
        payload,
    };
}
